import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'core/context/app.context';
import { ActionCodes, CsatActions, GoTvActionCodes, PortugueseActionCodes, PortugueseGoTvActionCodes } from 'core/enums/genex';
import { SitePlatform } from 'core/enums/site-platform';
import { GenexStore } from 'core/stores/genex.store';
import { FriendlyPlatformNameMap } from 'core/stores/site-config.store';

export const usePlatform = () => {
  const appcontext = useContext(AppContext);
  const { t } = useTranslation();

  const platformKey = appcontext.platform;
  const platformName = FriendlyPlatformNameMap[platformKey];
  const platform = platformName;

  const translate = (i18nKey: string) => t(i18nKey, { platform });

  const genexActionCode = (csatCode: CsatActions) => {
    const isPlatformGotv = platformKey === SitePlatform.gotv;

    if (GenexStore.lang === 'pt') {
      return isPlatformGotv ? PortugueseGoTvActionCodes[csatCode] : PortugueseActionCodes[csatCode];
    }

    return isPlatformGotv ? GoTvActionCodes[csatCode] : ActionCodes[csatCode];
  };

  return {
    platform,
    platformName,
    platformKey,
    translate,
    genexActionCode,
  };
};